import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const CreditStatusContent = Loadable(() => import('../../containers/web/creditstatuscontent'));
export default MapTo('vcg/components/soe-home/react/creditstatuscontent')(CreditStatusContent);
